import * as React from 'react';
import { LinearProgress } from '@mui/material';

interface LoaderProps {}

const Loader: React.FC<LoaderProps> = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <LinearProgress />
    </div>
  );
};

export default Loader;
